"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGrid = void 0;
var react_1 = __importStar(require("react"));
var buttons_1 = require("../buttons");
var layout_1 = require("../layout");
var validation_1 = require("../validation");
var FormGridInternal = function (props, ref) {
    var _a = props.ctx, readOnly = _a.readOnly, model = _a.model, onChange = _a.onChange;
    var detailsRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)([]), invalidRows = _b[0], setInvalidRows = _b[1];
    var _c = (0, react_1.useState)([]), expanded = _c[0], setExpanded = _c[1];
    var _d = (0, react_1.useState)({
        columnIndex: -1,
        descending: true,
    }), sorting = _d[0], setSorting = _d[1];
    var onSort = function (columnIndex, descending) {
        var newRows = (0, layout_1.sortRows)(props.rows, props.columns, columnIndex, descending);
        onChange(props.setRows(model, newRows));
        setSorting({ columnIndex: columnIndex, descending: descending });
    };
    var _e = (0, react_1.useState)(0), validationCounter = _e[0], setValidationCounter = _e[1];
    var revalidate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newInvalidRows, rows, rowValidation, _i, rowValidation_1, v, errors, row;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newInvalidRows = [];
                    if (props.canExpand) {
                        rows = props.rows.filter(function (r) { return props.canExpand(r); });
                    }
                    else {
                        rows = props.rows;
                    }
                    return [4, Promise.all(rows.map(function (r) {
                            return (0, validation_1.validate)(props.schema, r);
                        }))];
                case 1:
                    rowValidation = _a.sent();
                    for (_i = 0, rowValidation_1 = rowValidation; _i < rowValidation_1.length; _i++) {
                        v = rowValidation_1[_i];
                        errors = v[0], row = v[1];
                        if (typeof errors == 'object' ? Object.keys(errors).length > 0 : errors) {
                            newInvalidRows.push(row);
                        }
                    }
                    setInvalidRows(newInvalidRows);
                    return [2];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (validationCounter == 0) {
            setTimeout(function () { return setValidationCounter(validationCounter + 1); }, 1);
        }
        else {
            revalidate();
        }
    }, [validationCounter]);
    (0, react_1.useEffect)(function () {
        props.ctx.resetErrorsFlag();
    }, [invalidRows, expanded]);
    (0, react_1.useEffect)(function () {
        var newInvalidRows = [];
        for (var _i = 0, invalidRows_1 = invalidRows; _i < invalidRows_1.length; _i++) {
            var r = invalidRows_1[_i];
            if (props.rows.indexOf(r) >= 0) {
                newInvalidRows.push(r);
            }
        }
        setInvalidRows(newInvalidRows);
    }, [props.rows]);
    var onRowChange = function (current, update) {
        var newRows = (0, layout_1.sortRows)((0, layout_1.mergeRows)(props.rows, current, update), props.columns, sorting.columnIndex, sorting.descending);
        setExpanded(expanded.filter(function (r) { return r != current; }));
        onChange(props.setRows(model, newRows));
    };
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        getUncommited: function (revalidate, colapse) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, current_1, update, invalid, newRows;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(detailsRef.current != null)) return [3, 2];
                        return [4, detailsRef.current.getUncommited(revalidate)];
                    case 1:
                        _a = _b.sent(), current_1 = _a[0], update = _a[1], invalid = _a[2];
                        newRows = (0, layout_1.sortRows)((0, layout_1.mergeRows)(props.rows, current_1, update), props.columns, sorting.columnIndex, sorting.descending);
                        if (colapse || (revalidate && !invalid)) {
                            setExpanded([]);
                        }
                        return [2, [newRows, invalid ? invalid : invalidRows.filter(function (r) { return r != current_1; }).length > 0]];
                    case 2: return [2, [props.rows, invalidRows.length > 0]];
                }
            });
        }); },
        revalidate: function () {
            setValidationCounter(validationCounter + 1);
        },
        setRows: function (model, newRows) {
            return props.setRows(model, newRows);
        },
    }); });
    var removeItem = function (e, r) {
        e.preventDefault();
        if (confirm('Remove?')) {
            var newRows = (0, layout_1.mergeRows)(props.rows, r, null);
            onChange(props.setRows(model, newRows));
            revalidate();
        }
    };
    var columns = props.columns.concat({
        footer: '',
        label: '',
        rightAlign: true,
        width: '10',
        sortable: false,
        value: function (r) {
            return !readOnly &&
                (props.canRemove === undefined || props.canRemove(r)) && (react_1.default.createElement(react_1.default.Fragment, null,
                invalidRows.indexOf(r) >= 0 ? react_1.default.createElement(layout_1.InvalidRowFlag, null) : react_1.default.createElement(react_1.default.Fragment, null),
                ' ',
                react_1.default.createElement("a", { href: "#", onKeyDown: function (e) {
                        if (e.key === 'Enter') {
                            removeItem(e, r);
                        }
                    }, onClick: function (e) { return removeItem(e, r); } }, "Remove")));
        },
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "row mt-4" },
            react_1.default.createElement("div", { className: "col" },
                react_1.default.createElement(layout_1.Header, { label: props.header }))),
        react_1.default.createElement("div", { className: "row mt-2" },
            react_1.default.createElement("div", { className: "col" }),
            props.additionalElement && react_1.default.createElement("div", { className: "col-auto p-0" }, props.additionalElement),
            react_1.default.createElement("div", { className: "col-auto" },
                ' ',
                !readOnly && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(buttons_1.Button, { id: "add-new-item-".concat(props.id), label: props.addButton, disabled: false, onClick: function () { return setExpanded([null]); } }))))),
        react_1.default.createElement(layout_1.DataGrid, { rows: props.rows, columns: columns, noRowsMessage: "There are no rows...", sort: {
                columnIndex: sorting.columnIndex,
                descending: sorting.descending,
                onChange: onSort,
            }, expand: {
                rows: expanded,
                canExpand: props.canExpand,
                onChange: setExpanded,
                content: function (current) {
                    return props.content({
                        row: current,
                        onChange: onRowChange,
                        readOnly: readOnly,
                        detailsRef: detailsRef,
                        schema: props.schema,
                        invalid: current ? invalidRows.indexOf(current) >= 0 : false,
                    });
                },
            } })));
};
var FormGridWithRef = (0, react_1.forwardRef)(FormGridInternal);
var _counter = 0;
var FormGrid = function (props) {
    var id = (0, react_1.useState)(++_counter)[0];
    return (react_1.default.createElement(FormGridWithRef, __assign({}, props, { ref: function (ref) {
            if (ref != null) {
                props.ctx.gridRefs.current[id] = ref;
            }
            else {
                delete props.ctx.gridRefs.current[id];
            }
        } })));
};
exports.FormGrid = FormGrid;
//# sourceMappingURL=FormGrid.js.map